import Link from 'next/link'
import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

import { burgerLevel1Adapter } from '@/shared/lib/utils/adapter/burgerAdapter'
import { TPage } from '@/shared/types/deprecated-types'

import cl from './HiddenMenu.module.scss'

/**
 * hidden burger component.
 */
export const HiddenMenu = (): JSX.Element => {
	const burger = useSelector(selectors.fullCategoriesBurger)

	const menuItems: TPage[] = [
		{
			title: `Каталог`,
			link: `/catalog`,
			items: burgerLevel1Adapter(Object.values(burger))
		}
	]

	return (
		<nav className={cl.hiddenMenu} aria-label="Каталог">
			<ul>
				{menuItems?.map(level1MenuItem => (
					<li key={level1MenuItem.title}>
						<Link
							href={level1MenuItem.link}
							prefetch={false}
							aria-label={`Сслыка на категорию "${level1MenuItem.title}"`}
							title={`Перейти в категорию "${level1MenuItem.title}"`}>
							{level1MenuItem.title}
						</Link>
						{!!level1MenuItem.items && (
							<ul>
								{level1MenuItem.items.map(level2MenuItem => (
									<li key={level2MenuItem.title}>
										{level2MenuItem.link ? (
											<Link
												href={level2MenuItem.link}
												prefetch={false}
												title={`Перейти в категорию "${level2MenuItem.title}"`}
												aria-label={`Ссылка на категорию "${level2MenuItem.title}"`}>
												{level2MenuItem.title}
											</Link>
										) : (
											<span>{level2MenuItem.title}</span>
										)}

										{!!level2MenuItem.items && (
											<ul>
												{level2MenuItem.items.map(level3MenuItem => (
													<li key={level3MenuItem.title}>
														{level3MenuItem.link ? (
															<Link
																href={level3MenuItem.link}
																prefetch={false}
																title={`Перейти в категорию "${level3MenuItem.title}"`}
																aria-label={`Ссылка на категорию "${level3MenuItem.title}"`}>
																{level3MenuItem.title}
															</Link>
														) : (
															<span>{level3MenuItem.title}</span>
														)}

														{!!level3MenuItem.items && (
															<ul>
																{level3MenuItem.items.map(level4MenuItem => (
																	<li key={level4MenuItem.title}>
																		{level4MenuItem.link ? (
																			<Link
																				href={level4MenuItem.link}
																				prefetch={false}
																				title={`Перейти в категорию "${level4MenuItem.title}"`}
																				aria-label={`Ссылка на категорию "${level4MenuItem.title}"`}>
																				{level4MenuItem.title}
																			</Link>
																		) : (
																			<span>{level4MenuItem.title}</span>
																		)}
																	</li>
																))}
															</ul>
														)}
													</li>
												))}
											</ul>
										)}
									</li>
								))}
							</ul>
						)}
					</li>
				))}
			</ul>
		</nav>
	)
}
